<template lang="pug">
v-simple-table
	template(#default)
		thead
			tr
				th.px-2(style="width:200px")
				th.px-2.text-center(style="width:120px") {{$t('areas_list_item.table_heading.piste')}}
				th.px-2.text-center(style="width:120px") {{$t('areas_list_item.table_heading.skilift')}}
				th.px-2.text-center.text-no-wrap(style="width:80px" v-for="feature in resorts[0].features") {{$t(`areas_list_item.table_heading.${feature.type.toLowerCase()}`)}}
		tbody
			tr(v-for="resort in resorts")
				td.text-no-wrap
					nuxt-link.mr-1(:to="localePath({name: 'resorts-resort', params: {resort: resort.slug}})" :title='`Wintersport ${resort.name}`') {{resort.name}}
					.caption.grey--text.d-inline ({{resort.elevation}}m)
				td.px-2.text-center
					ws-icon(v-if='resort.hasDownHill' color="success" size="20") check
					span.grey--text(v-else) •
				td.px-2.text-center
					ws-icon(v-if='resort.hasSkiLift' color="success" size="20") check
					span.grey--text(v-else) •
				td.px-2.text-center(v-for="feature in resort.features")
					ws-icon(circle :color="['', 'error', 'warning', 'success', 'success'][feature.rating]" dark small) {{['', 'minus', 'tilde', 'plus', 'plus'][feature.rating]}}

</template>

<style lang="sass">
.resort-table
  table
    table-layout: fixed
</style>

<script>
export default {
	props: {
		resorts: {
			type: Array,
			default: () => []
		},
		highlighted: {
			type: Array,
			default: () => []
		}
	}
};
</script>
